module.exports = __webpack_public_path__ + "assets/arrow_left_carousel-3c804e.svg";